import ChoiceEdit from "./ChoiceEdit";

interface BooleanEditProps {
  value: boolean;
  onChange: (_val: boolean) => void;
}

const BooleanEdit = ({ value, onChange }: BooleanEditProps) => (
  <ChoiceEdit
    getOptionLabel={(option: string) => option.charAt(0).toUpperCase() + option.slice(1)}
    onChange={(val) => onChange(val === "yes")}
    options={["yes", "no"]}
    value={value ? "yes" : "no"}
    disableClearable
  />
);

export default BooleanEdit;
